exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".axis path,.axis line{fill:none;stroke:#000;shape-rendering:crispEdges}.areaPath1{fill:#3bcbe380}.areaPath2{fill:#5262ade8}.areaPath3{fill:#8775a7}.overlay{fill:none !important;pointer-events:all}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/multiAreaChart/AreaChartWithAxis/AreaChartWithAxis.scss
// module id = 1456
// module chunks = 0